import React, {Fragment} from 'react'
import {useParams, Link, useLocation} from 'react-router-dom'
import {formatTime} from 'admin/lib/format'
import {compact} from 'lodash'
import ModalLink from './shared/ModalLink'

const LinkOrNot = ({children, ...props}) => {
  const location = useLocation()
  const isCurrentPage = location.pathname === props.to
  return isCurrentPage ? children : <Link {...props}>{children}</Link>
}

export default ({alert, onClear, className}) => {
  const {organisationID} = useParams()

  return (
    <div className={`notification is-danger is-light px-5 ${className}`}>
      <div className='columns is-vcentered is-mobile'>
        <div className='column p-0 is-size-6' style={{flex: 1}}>
          {alert.payload.timestamp
            ? `${formatTime(alert.payload.timestamp)} - `
            : alert.activateAt
              ? `${formatTime(alert.activateAt)} - `
              : `${formatTime(alert.createdAt)} - `}
          {alert.type == 'overdue' ? (
            <Fragment>
              <LinkOrNot to={`/orgs/${organisationID}/accounts/${alert.account.id}`}>
                {alert.account.displayName}
              </LinkOrNot>{' '}
              needs a statement (first SMS warning sent)
            </Fragment>
          ) : alert.type == 'suspension' ? (
            <Fragment>
              <LinkOrNot to={`/orgs/${organisationID}/accounts/${alert.account.id}`}>
                {alert.account.displayName}
              </LinkOrNot>{' '}
              needs to be suspended
            </Fragment>
          ) : alert.type == 'bad_mobile_number' ? (
            <Fragment>
              <ModalLink modal='text-message' params={{textMessageId: alert.payload.textMessageId}}>
                Text Message
              </ModalLink>{' '}
              to {alert.payload.mobileNumber} failed (bad mobile number)
            </Fragment>
          ) : alert.type == 'no_mobile_number' ? (
            <Fragment>
              <ModalLink modal='text-message' params={{textMessageId: alert.payload.textMessageId}}>
                Text Message
              </ModalLink>{' '}
              not sent (no mobile number)
            </Fragment>
          ) : alert.type == 'email_bounce' ? (
            <Fragment>
              Email to {alert.payload.emailAddress} failed ({alert.payload.bounceType} bounce).
            </Fragment>
          ) : alert.type == 'email_complaint' ? (
            <Fragment>
              Email to {alert.payload.emailAddress} was reported as spam ({alert.payload.complaintFeedbackType}).
            </Fragment>
          ) : alert.type == 'ip_sheet' ? (
            <Fragment>
              <a
                href={`${alert.payload.sheetUrl}&range=${alert.payload.row}:${alert.payload.row}`}
                target='_blank'
                className='is-underlined'>
                {compact([alert.payload.sheetName, alert.payload.cell, alert.payload.nameColumn]).join(' ')}
              </a>{' '}
              was edited{' '}
              {alert.payload.oldValue && alert.payload.newValue ? (
                <Fragment>
                  (<b className='has-text-weight-bold'>{alert.payload.oldValue}</b> changed to{' '}
                  <b className='has-text-weight-bold'>{alert.payload.newValue}</b>)
                </Fragment>
              ) : alert.payload.oldValue ? (
                <Fragment>
                  (<b className='has-text-weight-bold'>{alert.payload.oldValue}</b> removed)
                </Fragment>
              ) : alert.payload.newValue ? (
                <Fragment>
                  (<b className='has-text-weight-bold'>{alert.payload.newValue}</b> added)
                </Fragment>
              ) : null}
            </Fragment>
          ) : null}
        </div>
        <div className='column p-0' style={{flex: '0 auto'}}>
          <button onClick={onClear} className='button is-small is-danger has-text-weight-semibold'>
            Clear
          </button>
        </div>
      </div>
    </div>
  )
}
